export const firebaseConfig = {
    apiKey: "AIzaSyBm0alr9Tw9gSkLpmf2sBluzVBDYz_XdlQ",
    authDomain: "weth-store.firebaseapp.com",
    databaseURL: "https://weth-store.firebaseio.com",
    projectId: "weth-store",
    storageBucket: "weth-store.appspot.com",
    messagingSenderId: "529439082626",
    appId: "1:529439082626:web:e914acaca10c1fb86ccc9b",
    measurementId: "G-EL06K4J5HS"
}